import React, { useState } from "react";

interface ReportModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: { reason: string; context: string }) => void;
}

const ReportModal: React.FC<ReportModalProps> = ({ isOpen, onClose, onSubmit }) => {
  const [reason, setReason] = useState("");
  const [context, setContext] = useState("");
  const [reportId, setReportId] = useState("");

  const handleSubmit = () => {
    if (!reason) {
      alert("Please provide a reason for reporting.");
      return;
    }
    if (!reportId) {
        onSubmit({ reason, context });
    }
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-md shadow-lg w-96">
        <h2 className="text-lg font-semibold mb-4">Report Content</h2>
        <div className="mb-4">
          <label className="block font-medium mb-1">Reason</label>
          <select
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            className="w-full px-3 py-2 border rounded-md"
          >
            <option value="" disabled>
              Select a reason
            </option>
            <option value="Spam">Spam</option>
            <option value="Inappropriate Content">Inappropriate Content</option>
            <option value="Other">Other</option>
          </select>
        </div>
        {reason === "Other" && (
          <div className="mb-4">
            <label className="block font-medium mb-1">Context</label>
            <textarea
              value={context}
              onChange={(e) => setContext(e.target.value)}
              className="w-full px-3 py-2 border rounded-md"
              placeholder="Provide additional details..."
            />
          </div>
        )}
          <div className="hidden">
            <label htmlFor="reportId">Leave this field blank</label>
            <input
              id="reportId"
              type="text"
              value={reportId}
              onChange={(e) => setReportId(e.target.value)}
            />
          </div>
        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportModal;
